export const GET_SESSION_VISA_REQUEST = "GET_SESSION_VISA_REQUEST";
export const GET_SESSION_VISA_RESPONSE = "GET_SESSION_VISA_RESPONSE";
export const AUTHORIZE_TRANSACTION_REQUEST = "AUTHORIZE_TRANSACTION_REQUEST";
export const AUTHORIZE_TRANSACTION_RESPONSE = "AUTHORIZE_TRANSACTION_RESPONSE";
export const CLEAR_SESSION_PAYMENT = "CLEAR_SESSION_PAYMENT";
export const GET_CODE_PAGO_EFECTIVO_REQUEST = "GET_CODE_PAGO_EFECTIVO_REQUEST";
export const GET_CODE_PAGO_EFECTIVO_RESPONSE = "GET_CODE_PAGO_EFECTIVO_RESPONSE";
